<div class="wrapper">
  <mat-card>
    <mat-card-content>
      @if (isTimedOut) {
      <app-mfa-fail [errorType]="MfaErrors.IS_TIMED_OUT"></app-mfa-fail>
      } @else {
      <button
        mat-icon-button
        class="close-button"
        aria-label="close"
        (click)="onDismiss()"
      >
        <mat-icon>close</mat-icon>
      </button>
      @switch (currentScreen) {@case (SetUpTwoFactorScreen.CHOOSE_METHOD) {
      <app-set-up-choose-method
        (dismiss)="onDismiss()"
        (changeScreen)="changeScreen($event)"
      ></app-set-up-choose-method>
      } @case (SetUpTwoFactorScreen.AUTHENTICATOR_APP) {
      <app-set-up-app
        (dismiss)="close()"
        (changeScreen)="changeScreen($event)"
      ></app-set-up-app>
      } @case (SetUpTwoFactorScreen.EMAIL) {
      <app-set-up-email
        [email]="email"
        (dismiss)="onResetTimer()"
        (dismiss)="close()"
        (changeScreen)="changeScreen($event)"
      ></app-set-up-email>
      } @case (SetUpTwoFactorScreen.FINAL) {
      <app-set-up-final
        [isSetupCompleted]="isSetupCompleted"
        (close)="close()"
      ></app-set-up-final>
      } @default {
      <app-set-up-initial
        [email]="email"
        (dismiss)="onDismiss()"
        (changeScreen)="changeScreen($event)"
      ></app-set-up-initial
      >} } }
    </mat-card-content>
  </mat-card>

  <div class="footer">
    <a
      href="https://www.actabl.com/privacy-policy"
      target="_blank"
      class="link-secondary"
      >{{ 'login.privacyPolicy' | translate }}</a
    >
  </div>
</div>
